import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CustomIcons } from '@shared/models/custom-icons';
import { map, tap } from 'rxjs/operators';
import { chunk } from 'lodash';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { combineLatest, Observable } from 'rxjs';
import { VkCardData } from '@shared/components/vk-card/models';
import { Select, Store } from '@ngxs/store';
import { GetVkNews } from '@shared/state/shared/shared.action';
import { SharedState } from '@shared/state/shared/shared.state';
import { TranslateService } from '@ngx-translate/core';
import { Locale } from '@shared/models/locale';
import { LangChangeEvent } from '@ngx-translate/core/lib/translate.service';
import { ServerLinks } from '@shared/services/server-links';
import { ServerLinkName } from '@shared/models/server-links-model';

@Component({
  selector: 'app-vk-block',
  templateUrl: './vk-block.component.html',
  styleUrls: ['./vk-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VkBlockComponent implements OnInit {
  public icons = CustomIcons;
  public isRuLocale = true;
  public langChange$: Observable<LangChangeEvent>;
  public vkLink: string;
  public vkBoard: string;
  public vkForum: string;
  public breakPointObserve$ = this.breakpointObserver.observe(['(max-width: 1024px)', '(max-width: 662px)']).pipe(
    map((state: BreakpointState) => {
      if (state.breakpoints['(max-width: 662px)']) return 1;
      if (state.breakpoints['(max-width: 1024px)']) return 2;
      return 3;
    })
  );

  @Select(SharedState.getVkNews) public vkPosts$: Observable<VkCardData[]>;

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  public postSlides$ = combineLatest([this.vkPosts$, this.breakPointObserve$]).pipe(
    map(([posts, slidesAmount]: [VkCardData[], number]) => chunk(posts, slidesAmount))
  );

  constructor(
    private breakpointObserver: BreakpointObserver,
    private store: Store,
    private translateService: TranslateService,
    private serverLink: ServerLinks
  ) {
    this.vkLink = this.serverLink.getLink(ServerLinkName.VkGroupLink);
    this.vkBoard = this.serverLink.getLink(ServerLinkName.VkBoardLink);
    this.vkForum = `${this.serverLink.getLink(ServerLinkName.VkForumLink)}?q=%23%D0%BE%D0%BF%D1%80%D0%BE%D1%81_%D0%9E%D0%9F%D0%9E%D0%94`;
  }

  private setLocale(lang: Locale): void {
    if (lang === Locale.RU_RU) {
      this.isRuLocale = true;
    } else {
      this.isRuLocale = false;
    }
  }

  public ngOnInit(): void {
    this.setLocale(this.translateService.currentLang as Locale);
    this.langChange$ = this.translateService.onLangChange.pipe(
      tap(res => {
        this.setLocale(res.lang as Locale);
      })
    );
    this.store.dispatch(new GetVkNews());
  }
}
